export default __webpack_public_path__ + "static/media/line-h-05.0ce843f2.png";